import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { AppState } from 'src/app/@store/app.reducers';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';

import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-buscar-siniestro',
    templateUrl: './modal-buscar-siniestro.component.html',
    styleUrls: ['./modal-buscar-siniestro.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCardContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, UpperCaseTextDirective, MatError, OnlyNumber, MatCardActions, MatButton]
})
export class ModalBuscarSiniestroComponent {

  public formBusquedaSiniestro: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalBuscarSiniestroComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.cargarFormulario();
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close(this.formBusquedaSiniestro.getRawValue());
  }

  cargarFormulario() {
    this.formBusquedaSiniestro = new FormGroup({
      sucursal: new FormControl(null),
      consecutivo: new FormControl(null),
      anio: new FormControl(moment().year()),
    });
  }
}
